import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { connect } from 'react-redux';
import { modalActions } from '../../../../Actions';
import { inputHelper } from '../../../../Helpers';
import styles from './applicability.module.scss';
import Tag from '../../../Tag/Tag';
import ApplicableProdModal from '../../../Modals/ApplicabilityModal/ApplicableProdModal';

const Products = (props) => {
	const {
		fields,
		isDisabled,
		toggleApplicableProductsModal,
		handleConfirm,
	} = props;
	const handleClick = () => {
		toggleApplicableProductsModal(true);
	};
	const handleDelete = (e) => {
		const { dataset } = inputHelper(e);
		props.handleDelete(dataset.id, 'applicableProducts', 'id');
	};
	const generateTags = (allTags, type) => {
		return allTags.map((tag) => {
			return (
				<Tag
					className={`${styles.tag}`}
					handleDelete={handleDelete}
					text={tag.productName}
					isDisabled={isDisabled}
					dataAttrs={{
						'data-type': type,
						'data-id': tag.id,
						'data-name': 'applicableProducts',
					}}
				/>
			);
		});
	};
	return (
		<div className={`${styles.root} ${isDisabled ? styles.disabled : ''}`}>
			<div className='form-field row'>
				<label className='form-label'>
					Applicable Product
				</label>
				<div className={`${styles['tag-wrapper']}`}>
					{fields.applicableProducts &&
						generateTags(
							fields.applicableProducts,
							'applicableProducts'
						)}
					{!isDisabled && (
						<div className={`${styles.add}`} onClick={handleClick}>
							<AddOutlinedIcon
								fontSize='medium'
								color='primary'
								dataAttrs={{
									'data-type': 'applicableProducts',
									'data-id': Products,
									'data-name': 'applicableProducts',
								}}
							/>
						</div>
					)}
				</div>

				<ApplicableProdModal
					handleConfirm={handleConfirm}
					selectedProdList={[
						...fields.applicableProducts,
						...fields.nonapplicableProducts,
					]}
				/>
			</div>
		</div>
	);
};
const mapStateToProps = (state) => {
	const { data, show } = state.modal.applicable_products;
	return {
		show,
		data,
	};
};

const mapDispatchToProps = {
	toggleApplicableProductsModal:
		modalActions.toggleApplicableProductsModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Products);
